import React from 'react';

const TrustedContentIcon = () => {
  return (
    <svg className="platform-icon allservices-icon" width="28" height="28" viewBox="0 0 38 38">
      <defs>
        <style>
          {`.uuid-d17ab8ef-2669-408a-93d8-60828bdd8082{fill:#e00;}.uuid-c4741b83-a3db-4b6d-858c-b3ae14c63c56{fill:#fff;}.uuid-83ce5ebd-b119-4710-9c52-7f345a2ee75e{fill:#4d4d4d;}`}
        </style>
      </defs>
      <rect x="1" y="1" width="36" height="36" rx="9" ry="9" />
      <path
        className="uuid-83ce5ebd-b119-4710-9c52-7f345a2ee75e"
        d="m28,2.25c4.27338,0,7.75,3.47662,7.75,7.75v18c0,4.27338-3.47662,7.75-7.75,7.75H10c-4.27338,0-7.75-3.47662-7.75-7.75V10c0-4.27338,3.47662-7.75,7.75-7.75h18m0-1.25H10C5.02942,1,1,5.02942,1,10v18c0,4.97058,4.02942,9,9,9h18c4.97058,0,9-4.02942,9-9V10c0-4.97058-4.02942-9-9-9h0Z"
      />
      <path
        className="uuid-c4741b83-a3db-4b6d-858c-b3ae14c63c56"
        d="m28.44238,27.55762l-4.81836-4.81836c.71344-.69464,1.27753-1.55255,1.62305-2.53125.11523-.3252-.05566-.68262-.38086-.79688-.32422-.11523-.68359.05469-.79688.38086-.75781,2.14258-2.79492,3.58301-5.06934,3.58301-2.96387,0-5.375-2.41113-5.375-5.375s2.41113-5.375,5.375-5.375c.34473,0,.625-.28027.625-.625s-.28027-.625-.625-.625c-3.65332,0-6.625,2.97168-6.625,6.625s2.97168,6.625,6.625,6.625c1.32489,0,2.57733-.40747,3.6358-1.10443l4.92181,4.92181c.12207.12207.28223.18262.44238.18262s.32031-.06055.44238-.18262c.24316-.24414.24316-.64062,0-.88477Z"
      />
      <path
        className="uuid-d17ab8ef-2669-408a-93d8-60828bdd8082"
        d="m20.44238,27.55762l-2-2c-.24414-.24414-.64062-.24414-.88477,0-.24316.24414-.24316.64062,0,.88477l.90601.9054c-4.91901-.28046-8.83862-4.35986-8.83862-9.34778,0-5.16895,4.20605-9.375,9.375-9.375.34473,0,.625-.28027.625-.625s-.28027-.625-.625-.625c-5.8584,0-10.625,4.7666-10.625,10.625,0,5.69482,4.50757,10.34442,10.14038,10.60046l-.95776.95715c-.24316.24414-.24316.64062,0,.88477.12207.12207.28223.18262.44238.18262s.32031-.06055.44238-.18262l2-2c.24316-.24414.24316-.64062,0-.88477Z"
      />
      <path
        className="uuid-d17ab8ef-2669-408a-93d8-60828bdd8082"
        d="m25.5,17.625c-2.27441,0-4.125-1.85059-4.125-4.125v-4.02832c0-.29492.20605-.5498.49512-.61133l3.5-.74414c.08594-.01758.17383-.01758.25977,0l3.5.74414c.28906.06152.49512.31641.49512.61133v4.02832c0,2.27441-1.85059,4.125-4.125,4.125Zm-2.875-7.64746v3.52246c0,1.58496,1.29004,2.875,2.875,2.875s2.875-1.29004,2.875-2.875v-3.52246l-2.875-.61133-2.875.61133Z"
      />
      <path
        className="uuid-c4741b83-a3db-4b6d-858c-b3ae14c63c56"
        d="m25,14.35254c-.16016,0-.32031-.06055-.44238-.18262l-1-1c-.24316-.24414-.24316-.64062,0-.88477.24414-.24414.64062-.24414.88477,0l.55762.55859,1.55762-1.55859c.24414-.24414.64062-.24414.88477,0,.24316.24414.24316.64062,0,.88477l-2,2c-.12207.12207-.28223.18262-.44238.18262Z"
      />
    </svg>
  );
};
export default TrustedContentIcon;
